/// HOOKS ///
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import useDrawOrderSlab from "hooks/draw_order_slab";
/// TYPES ///
import { OrderSlab } from "api/types/order/order";
import { SelfOrderSlab } from "api/types/order/self_order";
/// MUI COMPONENTS ///
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
/// SKETCH FUNCTIONS ///
import { getCanvas } from "functions/sketch/context";
/// STYLES ///
import { shape_container_style } from "styles/quote_preview/sketch";

interface Props {
  index: number,
  slab: OrderSlab | SelfOrderSlab,
  shapes_loaded: boolean
}

export default function DiagramSlab({ index, slab, shapes_loaded }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const canvas_id = `slab_canvas_${slab.id}`;
  const [load_drawing, setLoadDrawing] = useState<boolean>(false);

  useDrawOrderSlab(index, slab, load_drawing && shapes_loaded);

  useEffect(() => {
    if (ref && ref.current) {
      const height: number = ref.current.clientHeight;
      const width: number = ref.current.clientWidth;
      const canvas: HTMLCanvasElement | null = getCanvas(document.getElementById(canvas_id));

      if (canvas) {
        canvas.width = width;
        canvas.height = height;
      }

      setLoadDrawing(true);
    }
  }, [ref, canvas_id]);

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Box sx={shape_container_style} ref={ref}>
        <canvas id={canvas_id} />
      </Box>
    </Grid>
  )
}
